import React from "react"
import { Typeahead } from "react-bootstrap-typeahead"
import { 
  Button, 
  ControlLabel, 
  FormControl, 
  FormGroup, 
  Glyphicon, 
  InputGroup, 
  Well } from "react-bootstrap"

import ExportAssignmentMetrics from "./ExportAssignmentMetrics"


export default function MetricsFilterSidebar(props) {
  // PROPS
  const { 
    sortMetricsBy,
    handleSortMetricsBy,
    metricsFilters,
    allAssignmentMetrics,
    handleFilterChange,
    handleSearchSubmit,
    users,
    functionalGroups,
    assessments
  } = props

  const availableVersions = allAssignmentMetrics.map((metric) => metric.version);
  const uniqueVersions = [...new Set(availableVersions)]
    .filter(version => version != null) // Remove null or undefined values
    .map(version => parseInt(version, 10)) // Convert to integers for numeric sorting
    .sort((a, b) => a - b) // Sort numerically
    .map(version => String(version)); // Convert back to strings


  // RENDER
  return (
    <div id="QMS-Filters-Sidebar">
      <Well>
        <center>
          <h3>Sort by</h3>
          <FormControl
              componentClass="select"
              placeholder="Sort Metrics"
              value={sortMetricsBy}
              onChange={(e) => handleSortMetricsBy(e.target.value)}
          >
            <option value="due">Due Date</option>
            <option value="functional_group">Group</option>
            <option value="status">Status</option>
            <option value="assessment">Title</option>
            <option value="user">User</option>

          </FormControl>
        </center>
  
        <center>
          <h3>Search</h3>
        </center>
  
        <FormGroup>
          <ControlLabel>Search by User or Title:</ControlLabel>
          <InputGroup>
            <FormControl
              type="text"
              value={ metricsFilters.searchTerm }
              placeholder="Search by User or Title:"
              onChange={ (e) => handleFilterChange('searchTerm', e.target.value) }
              onKeyDown={ (e) => e.key === 'Enter' ? handleSearchSubmit() : null }
            />
            <InputGroup.Button>
              <Button
                bsStyle="default"
                onClick={ handleSearchSubmit }
              >
                <Glyphicon glyph="search" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
        <hr />
  
        <center>
          <h3>Filter By</h3>
        </center>
  
        <div>
          <h5>User(s)</h5>
          <Typeahead
            id="AuthorFilterTypeahead"
            clearButton
            labelKey={(user) => `${user.first_name} ${user.last_name}`}
            multiple
            selected={metricsFilters.selectedUsers}
            options={(users || []).sort((a, b) => {
              const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
              const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
              return nameA.localeCompare(nameB);
            })}
            placeholder="Enter Genesis Users"
            onChange={(users) => handleFilterChange('selectedUsers', users)}
          />
        </div>
        <div>
          <h5>Functional Group(s)</h5>
          <Typeahead
            id="FunctionalGroupFilterTypeahead"
            clearButton
            labelKey={(group) => group.name}
            multiple
            selected={metricsFilters.selectedFunctionalGroups}
            options={(functionalGroups || []).sort((a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();
              return nameA.localeCompare(nameB);
            })}
            placeholder="Enter Functional Group(s)"
            onChange={(groups) => handleFilterChange('selectedFunctionalGroups', groups)}
          />
        </div>
        <div>
          <h5>Title(s)</h5>
          <Typeahead
            id="AssessmentFilterTypeahead"
            clearButton
            labelKey={(assessment) => assessment.name}
            multiple
            selected={metricsFilters.selectedAssessments}
            options={(assessments || []).sort((a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();
              return nameA.localeCompare(nameB);
            })}
            placeholder="Enter Title(s)"
            onChange={(assessments) => handleFilterChange('selectedAssessments', assessments)}
          />
        </div>
        <div>
          <h5>Attempt Status</h5>
          <Typeahead
            id="AttempStatusFilterTypeahead"
            clearButton
            multiple
            selected={metricsFilters.selectedAttemptStatuses}
            options={ ["Not Taken", "Past Due", "Passed", "Failed"].sort() }
            placeholder="Enter Attempt Status"
            onChange={(statuses) => handleFilterChange('selectedAttemptStatuses', statuses)}
          />
        </div>
        
        <div>
          <h5>Version(s)</h5>
          <Typeahead
            id="VersionFilterTypeahead"
            clearButton
            labelKey="version"
            multiple
            selected={metricsFilters.selectedVersions}
            options={uniqueVersions} // Use the sorted and stringified versions
            placeholder="Enter Version(s)"
            onChange={(selectedVersions) => handleFilterChange('selectedVersions', selectedVersions)}
          />
        </div>

        <div>
          <h5>Published Status</h5>
          <Typeahead
            id="PublishedStatusFilterTypeahead"
            clearButton
            multiple
            selected={metricsFilters.selectedPublishedStatuses}
            options={["Published", "Not Published"]}
            placeholder="Select Published Status"
            onChange={(statuses) => handleFilterChange("selectedPublishedStatuses", statuses)}
          />
        </div>

        <hr />
        <center>
          <ExportAssignmentMetrics 
            sortMetricsBy={sortMetricsBy}
            metricsFilters={metricsFilters}
          />
        </center>
      </Well>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/AssignmentMetricsContainer/MetricsFilterSidebar.js